module.exports = __webpack_public_path__ + "static/1_mobile-a7f8424663d2ec00b1eda2554d9964c6.jpg";